import axios from 'axios';

export const getSalesSetting = (
  target: number,
  start_year: string,
  start_month: string,
  end_year: string,
  end_month: string
) => {
  return axios
    .get(
      `/api/v1/sales/settings?target=${target}&start_year=${start_year}&start_month=${start_month}&end_year=${end_year}&end_month=${end_month}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const saveSalesSetting = (
  target_year: string,
  target_month: string,
  target: number,
  sales: number,
  gross_profit: number,
  cost: number,
  gross_profit_rate: number,
  no_of_business_projects: number,
  no_of_construction_projects: number,
  no_of_completed_projects: number
) => {
  return axios
    .post(
      `/api/v1/sales/settings`,
      {
        target_year,
        target_month,
        target,
        sales,
        gross_profit,
        cost,
        gross_profit_rate,
        no_of_business_projects,
        no_of_construction_projects,
        no_of_completed_projects
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateSalesSetting = (
  target_year: string,
  target_month: string,
  target: number,
  sales: number,
  gross_profit: number,
  cost: number,
  gross_profit_rate: number,
  no_of_business_projects: number,
  no_of_construction_projects: number,
  no_of_completed_projects: number
) => {
  return axios
    .put(
      `/api/v1/sales/settings`,
      {
        target_year,
        target_month,
        target,
        sales,
        gross_profit,
        cost,
        gross_profit_rate,
        no_of_business_projects,
        no_of_construction_projects,
        no_of_completed_projects
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getSalesValues = (
  target: number,
  target_year: string,
  target_month: string
) => {
  return axios
    .get(
      `/api/v1/sales/values?target=${target}&target_year=${target_year}&target_month=${target_month}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteSalesSetting = (
  target_year: string,
  target_month: string,
  target: number
) => {
  return axios
    .delete(`/api/v1/sales/settings`, {
      data: {
        target_year,
        target_month,
        target
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
